var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "function-list" } },
    [
      _vm.createMode
        ? _c("FunctionEditor", {
            attrs: { createMode: "" },
            on: {
              close: function ($event) {
                _vm.createMode = false
              },
              save: _vm.saveFunction,
            },
          })
        : [
            _vm.selectedFunction
              ? _c("FunctionEditor", {
                  attrs: { "story-id": _vm.storyId },
                  on: {
                    close: function ($event) {
                      _vm.selectedFunction = null
                    },
                    deleted: function () {
                      return _vm.onDeletedSingle(_vm.selectedFunction._id)
                    },
                    save: _vm.updateFunction,
                  },
                  model: {
                    value: _vm.selectedFunction.aiFunction,
                    callback: function ($$v) {
                      _vm.$set(_vm.selectedFunction, "aiFunction", $$v)
                    },
                    expression: "selectedFunction.aiFunction",
                  },
                })
              : !_vm.selectedFunction
              ? _c("div", { staticClass: "fn-container" }, [
                  _c("div", { staticClass: "header" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("chatbotv2.aiFunctions")) +
                          "\n                        "
                      ),
                      _c(
                        "i",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                content: _vm.$t(
                                  "chatbotv2.aiFunctionCreateHint"
                                ),
                                placement: "bottom",
                                theme: "light",
                              },
                              expression:
                                "{ \n                            content: $t('chatbotv2.aiFunctionCreateHint'),\n                            placement: 'bottom',\n                            theme: 'light'\n                        }",
                            },
                          ],
                          staticClass: "material-icons info-icon",
                        },
                        [
                          _vm._v(
                            "\n                        info\n                    "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "actions" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            attrs: { primary: "" },
                            on: {
                              click: function ($event) {
                                _vm.createMode = true
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("add"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.addFunction"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("ve-pagination", {
                        attrs: {
                          total: _vm.total,
                          "page-index": _vm.page,
                          "page-size": _vm.pageSize,
                          "page-size-option": [10, 15, 20, 50, 100],
                        },
                        on: {
                          "on-page-number-change": function (val) {
                            return (_vm.page = val)
                          },
                          "on-page-size-change": function (val) {
                            return (_vm.pageSize = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "function-table" }, [
                      _c(
                        "div",
                        { staticClass: "function-table-header" },
                        _vm._l(_vm.columns, function (column) {
                          return _c(
                            "div",
                            {
                              key: column.id,
                              staticClass: "function-table-header-item",
                              style: {
                                flex: column.flex,
                                width: column.width
                                  ? column.width + "px"
                                  : "auto",
                                "max-width": column.maxWidth
                                  ? column.maxWidth + "px"
                                  : "auto",
                              },
                            },
                            [
                              column.isCheckbox
                                ? _c("a-checkbox", {
                                    attrs: { checked: _vm.isSelectAll() },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.toggleSelectAll.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  })
                                : [_vm._v(_vm._s(column.title))],
                            ],
                            2
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "function-table-body" },
                        _vm._l(_vm.filteredRows, function (row) {
                          return _c(
                            "div",
                            { key: row._id, staticClass: "row" },
                            _vm._l(_vm.columns, function (column) {
                              return _c(
                                "div",
                                {
                                  key: column.id,
                                  staticClass: "cell",
                                  style: {
                                    flex: column.flex,
                                    width: column.width
                                      ? column.width + "px"
                                      : "auto",
                                    "max-width": column.maxWidth
                                      ? column.maxWidth + "px"
                                      : "auto",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.previewArticles(row)
                                    },
                                  },
                                },
                                [
                                  column.slot === "state"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "d-flex w-100" },
                                          [
                                            row.enabled
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "state-cell active",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "chatbotv2.usedByAi"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "state-cell passive",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "chatbotv2.notUsed"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                      ]
                                    : [
                                        column.isCheckbox
                                          ? [
                                              _c("a-checkbox", {
                                                attrs: {
                                                  checked: _vm.isSelected(row),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return function () {
                                                      return _vm.toggleSelect(
                                                        row
                                                      )
                                                    }.apply(null, arguments)
                                                  },
                                                },
                                              }),
                                            ]
                                          : [
                                              column.getData
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        column.getData(row)
                                                      )
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(row[column.id])
                                                    ),
                                                  ]),
                                            ],
                                      ],
                                ],
                                2
                              )
                            }),
                            0
                          )
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "built-in-functions-section" }, [
                      _c("h2", [
                        _vm._v(
                          _vm._s(_vm.$t("chatbotv2.builtInFunctionsTitle"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "section-description" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("chatbotv2.builtInFunctionsDesc")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "built-in-functions-list" },
                        [
                          _c("FeatureItem", {
                            attrs: {
                              title: _vm.$t(
                                "chatbotv2.builtInFunctionsOptionButtonsTitle"
                              ),
                              icon: "ChatAiIcon",
                              description: _vm.$t(
                                "chatbotv2.builtInFunctionsOptionButtonsDesc"
                              ),
                              type: "switch",
                            },
                            model: {
                              value: _vm.showOptionButtonsEnabled,
                              callback: function ($$v) {
                                _vm.showOptionButtonsEnabled = $$v
                              },
                              expression: "showOptionButtonsEnabled",
                            },
                          }),
                          _vm._v(" "),
                          _c("FeatureItem", {
                            attrs: {
                              title: _vm.$t(
                                "chatbotv2.builtInFunctionsCloseConversationTitle"
                              ),
                              icon: "ChatAiIcon",
                              description: _vm.$t(
                                "chatbotv2.builtInFunctionsCloseConversationDesc"
                              ),
                              type: "switch",
                            },
                            model: {
                              value: _vm.closeConversationEnabled,
                              callback: function ($$v) {
                                _vm.closeConversationEnabled = $$v
                              },
                              expression: "closeConversationEnabled",
                            },
                          }),
                          _vm._v(" "),
                          _c("FeatureItem", {
                            attrs: {
                              title: _vm.$t(
                                "chatbotv2.builtInFunctionsTransferChatTitle"
                              ),
                              icon: "ChatAiIcon",
                              description: _vm.$t(
                                "chatbotv2.builtInFunctionsTransferChatDesc"
                              ),
                              type: "switch",
                            },
                            model: {
                              value: _vm.transferChatEnabled,
                              callback: function ($$v) {
                                _vm.transferChatEnabled = $$v
                              },
                              expression: "transferChatEnabled",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.selectedItems.length
                      ? _c("div", { staticClass: "select-panel-wrapper" }, [
                          _c("div", { staticClass: "select-panel" }, [
                            _c("div", { staticClass: "items-count" }, [
                              _vm.busy
                                ? _c(
                                    "i",
                                    { staticClass: "material-icons spin" },
                                    [_vm._v('"autorenew"')]
                                  )
                                : _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("check"),
                                  ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.selectedItems.length) +
                                    " " +
                                    _vm._s(
                                      _vm.$t("auto.chatbotSelectedCountSuffix")
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "buttons" },
                              [
                                _c(
                                  "SupsisButton",
                                  {
                                    attrs: { small: "", disabled: _vm.busy },
                                    on: {
                                      click: function () {
                                        return _vm.deleteMulti()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("delete"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "SupsisButton",
                                  { attrs: { small: "", disabled: _vm.busy } },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("refresh"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "SupsisButton",
                                  {
                                    attrs: { disabled: _vm.busy },
                                    on: {
                                      click: function () {
                                        return _vm.multiChangeState(false)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("toggle_off"),
                                    ]),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("chatbotv2.disableAi")) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "SupsisButton",
                                  {
                                    attrs: { disabled: _vm.busy },
                                    on: {
                                      click: function () {
                                        return _vm.multiChangeState(true)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("toggle_on"),
                                    ]),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("chatbotv2.enableAi")) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }